import React from 'react'

const TouLogo = () => {
  return (
    <svg
      width="26"
      height="29"
      viewBox="0 0 26 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.67788 18.7201C1.70867 18.8691 -2.13591 12.1112 1.28558 7.43063C3.49299 4.82739 6.21547 2.64488 8.63442 0.216937C8.93794 -0.0723123 8.94714 -0.0723123 9.24146 0.216937C11.3201 2.19786 13.3988 4.17877 15.4774 6.15093C15.6889 6.37005 15.8085 6.44018 15.5234 6.67683C13.4815 8.63146 11.4397 10.5773 9.38862 12.5232C9.22306 12.6897 9.02072 12.8037 9.27825 13.014C10.4739 14.1623 11.6788 15.3017 12.8837 16.4499C13.0584 16.6253 13.0584 16.634 12.8837 16.8006C11.4949 18.0364 9.57257 18.7815 7.67788 18.7376V18.7201Z"
        fill="#5BCFAC"
      />
      <path
        d="M25.9901 17.528C25.9993 22.4189 20.4992 25.2851 17.4732 28.7035C17.0225 29.133 17.0869 29.0629 16.7006 28.7035C15.4589 27.529 14.2357 26.3545 12.994 25.1799C12.157 24.3911 11.32 23.6022 10.4831 22.8134C10.2531 22.5942 10.2439 22.5767 10.5015 22.3313C12.5801 20.3504 14.6588 18.3694 16.7374 16.3885C16.9306 16.1957 16.9306 16.1957 16.7374 16.0029C15.9096 15.2052 15.0726 14.4164 14.2357 13.6187C14.0425 13.3295 12.6537 12.4355 13.1596 12.2076C17.9515 7.95647 26.0821 11.2434 25.9993 17.5368L25.9901 17.528Z"
        fill="#5BCFAC"
      />
    </svg>
  )
}

export default TouLogo
